function getEnv(env: string, defaults: string): string {
  return import.meta.env[env] ?? defaults;
}

const Environment = {
  APP_VERSION: import.meta.env.APP_VERSION,
  ENV: getEnv('NODE_ENV', 'development'),
  API_URL: getEnv('VITE_API_URL', 'https://api.beconfident.app/v2'),
  API_SOCKET_URL: getEnv('VITE_API_SOCKET_URL', 'https://ws.beconfident.app/'),
  GOOGLE_WEB_CLIENT_ID: getEnv('VITE_GOOGLE_WEB_CLIENT_ID', ''),
  GOOGLE_IOS_CLIENT_ID: getEnv('VITE_GOOGLE_IOS_CLIENT_ID', ''),
  APP_NAME: getEnv('VITE_APP_NAME', 'BeConfident'),
  PLAYSTORE_URL: getEnv(
    'VITE_PLAYSTORE_URL',
    'https://play.google.com/store/apps/details?id=ai.beconfident.app',
  ),
  APPSTORE_URL: getEnv(
    'VITE_APPSTORE_URL',
    'https://apps.apple.com/us/app/beconfident/id6468505840',
  ),
  POSTHOG_ID: getEnv('VITE_POSTHOG_ID', ''),
  ENABLE_ANALYTICS_EVENTS: getEnv('VITE_ENABLE_ANALYTICS_EVENTS', ''),
  SENTRY_ENVIRONMENT: getEnv('VITE_SENTRY_ENVIRONMENT', ''),
  SENTRY_DSN: getEnv('VITE_SENTRY_DSN', ''),
};

export default Environment;
